import { getPageLayoutBounds } from '../PageLayout/PageLayout';
import { LELY_TOOLTIP_CARET_SIZE } from '../../styles/newStyles/lelyTooltipSurfaceStyles';

import type { ToggleTipPosition } from './toggleTip.styles';

const GAP_WITH_CHEVRON = 8;
const GAP_NO_CHEVRON = 4;
const PAGE_MARGIN = 16;

function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max);
}

function getContentBounds() {
  const { minLeft, maxRight } = getPageLayoutBounds(PAGE_MARGIN);
  return { minLeft, maxRight };
}

export const TOGGLE_TIP_Z_INDEX = 1400;

export function resolveToggleTipIcon(trigger: HTMLElement) {
  return trigger.querySelector('svg') ?? trigger;
}

export function positionToggleTipPanel(
  paper: HTMLElement,
  icon: Element,
  placement: ToggleTipPosition,
  showChevron: boolean,
) {
  const iconRect = icon.getBoundingClientRect();
  const width = paper.offsetWidth;
  const height = paper.offsetHeight;
  const { minLeft, maxRight } = getContentBounds();
  const gap = showChevron ? GAP_WITH_CHEVRON : GAP_NO_CHEVRON;
  const centerX = iconRect.left + iconRect.width / 2;
  const centerY = iconRect.top + iconRect.height / 2;

  let left = centerX - width / 2;
  let top = iconRect.bottom + gap;

  if (placement === 'top') {
    top = iconRect.top - gap - height;
  } else if (placement === 'right') {
    left = iconRect.right + gap;
    top = centerY - height / 2;
  } else if (placement === 'left') {
    left = iconRect.left - gap - width;
    top = centerY - height / 2;
  }

  if (placement === 'top' || placement === 'bottom') {
    left = clamp(left, minLeft, maxRight - width);
  }

  paper.style.left = `${Math.round(left)}px`;
  paper.style.top = `${Math.round(top)}px`;

  if (!showChevron) {
    return;
  }

  const paperRect = paper.getBoundingClientRect();
  const caretHalf = LELY_TOOLTIP_CARET_SIZE / 2;

  const arrowOffset =
    placement === 'left' || placement === 'right'
      ? clamp(
          centerY - paperRect.top - caretHalf,
          0,
          paperRect.height - LELY_TOOLTIP_CARET_SIZE,
        )
      : clamp(
          centerX - paperRect.left - caretHalf,
          0,
          paperRect.width - LELY_TOOLTIP_CARET_SIZE,
        );

  paper.style.setProperty('--toggle-tip-arrow-offset', `${arrowOffset}px`);
}
